import type { BgColor } from '~/types/pipeline';
import { BG_ALPHA_MIN } from './detect';

export function hasBgColor(
  rgb: readonly [number, number, number],
  list: readonly BgColor[],
): boolean {
  for (const c of list) {
    if (c.rgb[0] === rgb[0] && c.rgb[1] === rgb[1] && c.rgb[2] === rgb[2]) return true;
  }
  return false;
}

/**
 * Append the RGB at (x, y) to `existing` as a manual bg color (weight 0).
 * Returns null when the click is out of bounds, the pixel is mostly
 * transparent, or an entry with the same RGB already exists — callers
 * use null to skip the no-op store write.
 */
export function pickBgColorAt(
  image: ImageData,
  x: number,
  y: number,
  existing: readonly BgColor[],
): BgColor[] | null {
  const { data, width, height } = image;
  if (x < 0 || x >= width || y < 0 || y >= height) return null;
  const idx = (y * width + x) * 4;
  if ((data[idx + 3] ?? 0) < BG_ALPHA_MIN) return null;
  const r = data[idx] ?? 0;
  const g = data[idx + 1] ?? 0;
  const b = data[idx + 2] ?? 0;
  if (hasBgColor([r, g, b], existing)) return null;
  return [...existing, { rgb: [r, g, b], weight: 0 }];
}
